var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-labs.e3bd1a66.png","uri@2x": __webpack_public_path__ + "icon-labs.56cb4a9d.png","uri@3x": __webpack_public_path__ + "icon-labs.9c50ab01.png",
    width: 26,
    height: 23
});